module.exports = __webpack_public_path__ + "static/media/spain5.b00e539f.jpg";